import dynamic from 'next/dynamic';
import { StickyWrapper } from './styles';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';

const MobileMenu = dynamic(
  async () => import('./mobile-menu').then((m) => m.MobileMenu),
  {
    ssr: false,
    loading: () => (
      <StickyWrapper>
        <SkeletonLoader height="100%" />
      </StickyWrapper>
    ),
  }
);

export { MobileMenu };
